import React, { useRef, useState } from "react";
import {
  DndContext,
  useSensor,
  useSensors,
  PointerSensor,
} from "@dnd-kit/core";
import DraggableItem from "./DraggableItem.jsx";
import styled from "styled-components";

const DraggableArea = (props) => {
  const { children, objectList, setObjectList } = props;
  const [activeId, setActiveId] = useState(null);
  const ref = useRef(null);

  const handleDragStart = (event) => {
    setActiveId(event.active.id);
  };

  const handleDragEnd = (event) => {
    const { active, delta } = event;
    const { offsetWidth, offsetHeight } = ref.current;

    const activeId = active.id;

    setObjectList((prevList) =>
      prevList.map((object) => {
        if (object.obj_id === activeId) {
          const { left, top } = object;
          const newX = left + delta.x;
          const newY = top + delta.y;

          const activeRect = active.rect.current.initial;

          const maxX = offsetWidth - activeRect.width;
          const maxY = offsetHeight - activeRect.height;

          if (newX < 0 || newX > maxX || newY < 0 || newY > maxY) {
            setActiveId(null);
            return object;
          } else {
            return {
              ...object,
              left: newX,
              top: newY,
            };
          }
        } else {
          return object;
        }
      })
    );

    setActiveId(null);
  };

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8,
      },
    })
  );

  return (
    <S.DndWrap ref={ref}>
      <DndContext
        onDragStart={handleDragStart}
        onDragEnd={handleDragEnd}
        sensors={sensors}
      >
        {React.Children.map(children, (child) => {
          const id = child.props.id;
          const isActive = activeId === child.props.id;
          const activeObject = objectList.find(
            (object) => object.obj_id === child.props.id
          );
          return (
            <DraggableItem
              key={id}
              id={id}
              active={isActive}
              activeObject={activeObject}
            >
              {child}
            </DraggableItem>
          );
        })}
      </DndContext>
    </S.DndWrap>
  );
};

export default DraggableArea;

const S = {
  DndWrap: styled.div`
    width: 1600px;
    height: 800px;
    border: 1px solid black;
    position: relative;

    background-color: #ffffff;
    background-image: linear-gradient(to right, #cccccc 1px, transparent 1px),
      linear-gradient(to bottom, #cccccc 1px, transparent 1px);
    background-size: 10px 10px;
  `,
};
